// Mock data for Dr. Qasim Hussein Law Firm Website

export const translations = {
  ar: {
    // UI Common
    ui: {
      lawyerName: "د. قاسم حسين",
      lawyerTitle: "محامي دولي معتمد",
      britishCertified: "محامي معتمد من المحاكم البريطانية",
      verifyLicense: "تحقق من الترخيص",
      verifySRALicense: "تحقق من ترخيص SRA",
      chatWhatsApp: "تواصل عبر واتساب",
      chatWithUs: "تواصل معنا",
      selectLanguage: "اختر اللغة",
      fcaRegulated: "مرخص من FCA",
      noWinNoFee: "لا ربح، لا أتعاب",
      scroll: "اسحب للأسفل",
      amountRecovered: "مبلغ مُسترد",
      verified: "موثق",
      watchFullStory: "شاهد القصة الكاملة",
      verifiedSuccessStory: "قصة نجاح موثقة",
      moreClientReviews: "المزيد من آراء العملاء",
      recovered: "مُسترد",
      readyToRecover: "هل أنت مستعد لاسترداد أموالك؟",
      haveMoreQuestions: "هل لديك أسئلة أخرى؟",
      contactDirectly: "تواصل معنا مباشرة للحصول على استشارة مجانية وشخصية",
      address: "العنوان",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      workingHours: "ساعات العمل",
      freeConsultation: "استشارة مجانية 100%",
      noObligation: "بدون أي التزام - لا ربح، لا أتعاب",
      responseTime: "وقت الرد",
      languages: "لغات",
      clientRating: "تقييم العملاء",
      satisfaction: "رضا العملاء",
      happyClients: "عميل سعيد",
      freeConsult: "استشارة مجانية",
      inFavourOfClaimant: "لصالح المدعي",
      aboutLawyer: "عن المحامي",
      areasOfExpertise: "مجالات التخصص",
      backToWebsite: "العودة للموقع",
      responseWithin24h: "رد خلال 24 ساعة",
      confidential: "سرية تامة",
      yearsExperience: "سنوات خبرة",
      casesWon: "قضية ناجحة",
      getConsultationNow: "احصل على استشارة مجانية الآن",
      recoverFundsNow: "استرد أموالك الآن!",
      startRecoveryJourney: "تواصل معنا اليوم وابدأ رحلة استرداد أموالك",
      fullName: "الاسم الكامل",
      phoneNumber: "رقم الهاتف",
      emailAddress: "البريد الإلكتروني",
      amountLost: "المبلغ المفقود (بالدولار)",
      sraLicensed: "مرخص من SRA",
      successRate: "نسبة نجاح 87%",
      sending: "جاري الإرسال...",
      videoTestimonials: "شهادات فيديو من عملائنا"
    },
    // Navigation
    nav: {
      home: "الرئيسية",
      about: "عن المحامي",
      services: "الخدمات",
      cases: "قضايا ناجحة",
      howItWorks: "كيف نعمل",
      faq: "الأسئلة الشائعة",
      contact: "اتصل بنا",
      consultation: "استشارة مجانية"
    },
    // Hero Section
    hero: {
      title: "استرجع أموالك من شركات التداول المحتالة",
      subtitle: "المحامي د. قاسم حسين - خبير متخصص في استرداد الأموال من وسطاء الفوركس والخيارات الثنائية الاحتياليين",
      cta: "احصل على استشارة مجانية",
      secondaryCta: "اعرف المزيد",
      stats: {
        cases: "قضايا ناجحة",
        recovered: "مليون دولار مُسترد",
        clients: "عميل راضٍ",
        rate: "نسبة النجاح"
      }
    },
    // About Section
    about: {
      title: "عن المحامي د. قاسم حسين",
      subtitle: "خبرة قانونية متخصصة في استرداد الأموال",
      description: "المحامي د. قاسم حسين هو محامٍ دولي متخصص في قضايا الاحتيال المالي واسترداد الأموال من شركات التداول والوساطة المالية الاحتيالية. مع أكثر من 15 عامًا من الخبرة في التقاضي الدولي، نجح في استرداد ملايين الدولارات لعملائه من خلال المحاكم البريطانية والأوروبية.",
      expertise: [
        "استرداد الأموال من وسطاء الفوركس المحتالين",
        "قضايا الخيارات الثنائية والعملات المشفرة",
        "التقاضي الدولي في المحاكم البريطانية",
        "استرداد الأموال من منصات التداول غير المرخصة",
        "التعويضات القانونية عن الاحتيال المالي"
      ],
      certifications: "شهادات ومؤهلات",
      certs: [
        "دكتوراه في القانون التجاري الدولي",
        "عضو نقابة المحامين البريطانية",
        "محامي معتمد في المحاكم الأوروبية",
        "خبير في قانون الأوراق المالية والاستثمار"
      ]
    },
    // Services Section
    services: {
      title: "خدماتنا القانونية",
      subtitle: "حلول شاملة لاسترداد أموالك",
      list: [
        {
          title: "تقييم الحالة المجاني",
          description: "تحليل شامل لحالتك وتقييم فرص النجاح في استرداد أموالك مع استشارة قانونية مجانية",
          icon: "FileSearch"
        },
        {
          title: "التحقيق والبحث",
          description: "جمع الأدلة والوثائق اللازمة لإثبات الاحتيال وتتبع الشركات المحتالة",
          icon: "Search"
        },
        {
          title: "الإجراءات القانونية",
          description: "رفع الدعاوى القضائية في المحاكم البريطانية والدولية ضد الشركات المحتالة",
          icon: "Scale"
        },
        {
          title: "استرداد الأموال",
          description: "المتابعة الحثيثة حتى استرداد أموالك بالكامل مع التعويضات القانونية",
          icon: "DollarSign"
        },
        {
          title: "الدعم المستمر",
          description: "مرافقتك في كل خطوة من العملية القانونية مع تقارير دورية عن تقدم قضيتك",
          icon: "HeadphonesIcon"
        },
        {
          title: "الحماية القانونية",
          description: "تقديم المشورة لحمايتك من الاحتيال المستقبلي وتأمين استثماراتك",
          icon: "Shield"
        }
      ]
    },
    // Success Cases
    cases: {
      title: "قضايا ناجحة موثقة",
      subtitle: "انتصارات قانونية مدعومة بوثائق المحاكم البريطانية",
      viewDocument: "عرض الوثيقة",
      list: [
        {
          client: "محمد العلي",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "المحكمة العليا البريطانية",
          date: "مارس 2024",
          caseNumber: "HC-2023-002847",
          description: "استرداد كامل للأموال المسروقة من منصة فوركس احتيالية مع تعويضات إضافية"
        },
        {
          client: "سارة أحمد",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "المحكمة التجارية البريطانية",
          date: "يناير 2024",
          caseNumber: "BC-2023-001592",
          description: "حكم قضائي باسترداد الأموال من شركة خيارات ثنائية غير مرخصة"
        },
        {
          client: "أحمد الخطيب",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "المحكمة العليا البريطانية",
          date: "نوفمبر 2023",
          caseNumber: "HC-2023-001203",
          description: "أكبر قضية استرداد في تاريخ المكتب من منصة عملات مشفرة احتيالية"
        },
        {
          client: "ليلى حسن",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "المحكمة المدنية البريطانية",
          date: "سبتمبر 2023",
          caseNumber: "CC-2023-000876",
          description: "استرداد أموال مع فوائد قانونية من شركة استثمار وهمية"
        }
      ]
    },
    // How It Works
    howItWorks: {
      title: "كيف نسترجع أموالك",
      subtitle: "عملية واضحة ومدروسة من الاستشارة إلى الاسترداد",
      steps: [
        {
          number: "01",
          title: "الاستشارة الأولية",
          description: "تواصل معنا مجانًا وشارك تفاصيل حالتك. سنقيّم قضيتك ونحدد إمكانية استرداد أموالك خلال 24 ساعة."
        },
        {
          number: "02",
          title: "جمع الأدلة",
          description: "نجمع كافة المستندات والإثباتات اللازمة: سجلات التحويلات، المراسلات، لقطات الشاشة، وأي دليل يثبت الاحتيال."
        },
        {
          number: "03",
          title: "التحقيق القانوني",
          description: "نحقق في الشركة المحتالة، نتتبع أصولها، ونحدد الولاية القضائية المناسبة لرفع الدعوى."
        },
        {
          number: "04",
          title: "رفع الدعوى",
          description: "نرفع دعوى قضائية رسمية في المحاكم البريطانية أو الأوروبية ضد الشركة المحتالة ومسؤوليها."
        },
        {
          number: "05",
          title: "التقاضي والمتابعة",
          description: "نمثلك في المحكمة، نقدم الأدلة، ونتابع القضية حتى الحصول على حكم قضائي لصالحك."
        },
        {
          number: "06",
          title: "تنفيذ الحكم واسترداد الأموال",
          description: "بعد الحكم، نتابع تنفيذه قانونيًا حتى استرداد أموالك بالكامل مع التعويضات إلى حسابك البنكي."
        }
      ]
    },
    // FAQ
    faq: {
      title: "الأسئلة الشائعة",
      subtitle: "إجابات على أهم استفساراتك حول استرداد الأموال",
      questions: [
        {
          q: "ما هي نسبة نجاح استرداد الأموال؟",
          a: "نسبة نجاحنا تتجاوز 87% في القضايا التي نقبلها. نقوم بتقييم دقيق لكل حالة قبل قبولها لضمان أعلى فرص النجاح. نعمل فقط على القضايا التي لدينا ثقة كبيرة في إمكانية الفوز بها."
        },
        {
          q: "كم من الوقت تستغرق عملية استرداد الأموال؟",
          a: "تستغرق العملية عادة بين 6 إلى 18 شهرًا حسب تعقيد القضية والولاية القضائية. القضايا البسيطة قد تُحل في 4-6 أشهر، بينما القضايا الدولية المعقدة قد تستغرق حتى 24 شهرًا. نبقيك على اطلاع دائم بتقدم قضيتك."
        },
        {
          q: "ما هي تكلفة الخدمات القانونية؟",
          a: "نعمل بنظام الأتعاب المشروطة (No Win, No Fee) في معظم القضايا. لا تدفع شيئًا مقدمًا، ونحصل على نسبة متفق عليها فقط عند نجاح القضية واسترداد أموالك. الاستشارة الأولية مجانية تمامًا."
        },
        {
          q: "هل يمكنني استرداد أموالي إذا كانت الشركة مقرها خارج بلدي؟",
          a: "نعم، نحن متخصصون في القضايا الدولية. لدينا خبرة في التعامل مع شركات احتيالية في مختلف الدول. نرفع القضايا في المحاكم البريطانية والأوروبية التي لها صلاحية واسعة في قضايا الاحتيال الدولي."
        },
        {
          q: "ما المستندات المطلوبة لبدء القضية؟",
          a: "نحتاج إلى: سجلات التحويلات البنكية أو الإلكترونية، لقطات شاشة من المنصة، المراسلات مع الشركة (إيميلات، رسائل)، عقود أو اتفاقيات وقعتها، وأي مستند يثبت علاقتك بالشركة. حتى لو لم تمتلك كل شيء، يمكننا البدء بما لديك."
        },
        {
          q: "ماذا لو كانت الشركة أغلقت موقعها واختفت؟",
          a: "هذا لا يمنع استرداد أموالك. نستخدم تقنيات التحقيق المتقدمة لتتبع الشركة ومسؤوليها، وتحديد أصولها وحساباتها البنكية. العديد من قضايانا الناجحة كانت ضد شركات 'اختفت' ظاهريًا."
        },
        {
          q: "هل الاستشارة الأولية فعلاً مجانية؟",
          a: "نعم، الاستشارة الأولية مجانية 100% وبدون أي التزام. سنراجع حالتك، نقيّم فرص النجاح، ونقدم لك خطة عمل واضحة. لن تدفع أي شيء إلا إذا قررت المضي قدمًا وقبلنا قضيتك."
        },
        {
          q: "هل تتعاملون مع قضايا العملات المشفرة؟",
          a: "نعم، لدينا خبرة واسعة في قضايا احتيال العملات المشفرة بما في ذلك ICOs الاحتيالية، منصات التداول المزيفة، مخططات بونزي بالعملات المشفرة، وسرقة المحافظ الإلكترونية. استردينا ملايين الدولارات في هذا المجال."
        }
      ]
    },
    // Testimonials
    testimonials: {
      title: "آراء العملاء",
      subtitle: "قصص نجاح حقيقية من عملاء استردوا أموالهم",
      list: [
        {
          name: "محمد العلي",
          location: "الإمارات العربية المتحدة",
          amount: "$847,500",
          text: "لم أكن أتخيل أنني سأسترد أموالي بعد أن اختفت الشركة. د. قاسم حسين وفريقه كانوا محترفين للغاية وتابعوا القضية حتى النهاية. استردت كامل أموالي مع تعويضات إضافية. شكراً جزيلاً!",
          rating: 5
        },
        {
          name: "سارة أحمد",
          location: "المملكة العربية السعودية",
          amount: "$625,000",
          text: "خسرت مدخرات عمري في شركة خيارات ثنائية احتيالية. د. قاسم أعاد لي الأمل ونجح في استرداد أموالي خلال 11 شهرًا. العملية كانت شفافة وكنت على اطلاع دائم. أنصح الجميع بالتواصل معه.",
          rating: 5
        },
        {
          name: "أحمد الخطيب",
          location: "الكويت",
          amount: "$1,240,000",
          text: "أكثر من مليون دولار كانت ضائعة في منصة عملات مشفرة مزيفة. د. قاسم وفريقه حققوا المستحيل واستردوا كامل المبلغ. الاحترافية والخبرة القانونية التي تمتعوا بها كانت مذهلة.",
          rating: 5
        },
        {
          name: "ليلى حسن",
          location: "قطر",
          amount: "$395,000",
          text: "بعد أن فقدت الأمل في استرداد أموالي، وجدت د. قاسم حسين. لم يسترد أموالي فحسب، بل حصل لي على تعويضات إضافية عن الضرر. شكراً من القلب لهذا المحامي النزيه.",
          rating: 5
        }
      ]
    },
    // Contact
    contact: {
      title: "احصل على استشارة مجانية الآن",
      subtitle: "تواصل معنا اليوم وابدأ رحلة استرداد أموالك",
      form: {
        name: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        amount: "المبلغ المسروق (بالدولار)",
        company: "اسم الشركة المحتالة",
        message: "تفاصيل الحالة",
        submit: "إرسال الطلب",
        sending: "جاري الإرسال...",
        success: "تم إرسال طلبك بنجاح! سنتواصل معك خلال 24 ساعة.",
        error: "حدث خطأ. يرجى المحاولة مرة أخرى."
      },
      info: {
        title: "معلومات التواصل",
        address: "لندن، المملكة المتحدة",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "الأحد - الخميس: 9:00 - 18:00"
      }
    },
    // Footer
    footer: {
      description: "مكتب المحامي د. قاسم حسين - متخصصون في استرداد الأموال من شركات التداول المحتالة",
      quickLinks: "روابط سريعة",
      legal: "قانوني",
      privacy: "سياسة الخصوصية",
      terms: "الشروط والأحكام",
      disclaimer: "إخلاء المسؤولية",
      copyright: "© 2024 د. قاسم حسين. جميع الحقوق محفوظة.",
      followUs: "تابعنا"
    }
  },
  en: {
    // UI Common
    ui: {
      lawyerName: "Dr. Qasim Hussein",
      lawyerTitle: "Certified International Lawyer",
      britishCertified: "British Courts Certified",
      verifyLicense: "Verify License",
      verifySRALicense: "Verify SRA License",
      chatWhatsApp: "Chat on WhatsApp",
      chatWithUs: "Chat with us",
      selectLanguage: "Select Language",
      fcaRegulated: "FCA Regulated",
      noWinNoFee: "No Win, No Fee",
      scroll: "Scroll",
      amountRecovered: "Amount Recovered",
      verified: "Verified",
      watchFullStory: "Watch Full Story",
      verifiedSuccessStory: "Verified Success Story",
      moreClientReviews: "More Client Reviews",
      recovered: "Recovered",
      readyToRecover: "Ready to recover your funds?",
      haveMoreQuestions: "Have More Questions?",
      contactDirectly: "Contact us directly for a free, personalized consultation",
      address: "Address",
      email: "Email",
      phone: "Phone",
      workingHours: "Working Hours",
      freeConsultation: "100% Free Consultation",
      noObligation: "No obligation - No Win, No Fee",
      responseTime: "Response Time",
      languages: "Languages",
      clientRating: "Client Rating",
      satisfaction: "Satisfaction",
      happyClients: "Happy Clients",
      freeConsult: "Free Consult",
      inFavourOfClaimant: "IN FAVOUR OF CLAIMANT",
      aboutLawyer: "About the Lawyer",
      areasOfExpertise: "Areas of Expertise",
      backToWebsite: "Back to Website",
      responseWithin24h: "Response within 24h",
      confidential: "100% Confidential",
      yearsExperience: "Years Exp.",
      casesWon: "Cases Won",
      getConsultationNow: "Get Free Consultation Now",
      recoverFundsNow: "Recover Your Funds Now!",
      startRecoveryJourney: "Contact us today and start your recovery journey",
      fullName: "Full Name",
      phoneNumber: "Phone Number",
      emailAddress: "Email Address",
      amountLost: "Amount Lost (USD)",
      sraLicensed: "SRA Licensed",
      successRate: "87% Success Rate",
      sending: "Sending...",
      videoTestimonials: "Video Testimonials from Our Clients"
    },
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      cases: "Success Cases",
      howItWorks: "How It Works",
      faq: "FAQ",
      contact: "Contact",
      consultation: "Free Consultation"
    },
    hero: {
      title: "Recover Your Money from Fraudulent Trading Companies",
      subtitle: "Dr. Qasim Hussein - Expert Lawyer Specializing in Fund Recovery from Fraudulent Forex and Binary Options Brokers",
      cta: "Get Free Consultation",
      secondaryCta: "Learn More",
      stats: {
        cases: "Successful Cases",
        recovered: "Million Recovered",
        clients: "Satisfied Clients",
        rate: "Success Rate"
      }
    },
    about: {
      title: "About Dr. Qasim Hussein",
      subtitle: "Specialized Legal Expertise in Fund Recovery",
      description: "Dr. Qasim Hussein is an international lawyer specializing in financial fraud cases and fund recovery from fraudulent trading and brokerage companies. With over 15 years of experience in international litigation, he has successfully recovered millions of dollars for his clients through British and European courts.",
      expertise: [
        "Fund Recovery from Fraudulent Forex Brokers",
        "Binary Options and Cryptocurrency Cases",
        "International Litigation in British Courts",
        "Recovery from Unlicensed Trading Platforms",
        "Legal Compensation for Financial Fraud"
      ],
      certifications: "Certifications & Qualifications",
      certs: [
        "PhD in International Commercial Law",
        "Member of British Bar Association",
        "Certified Lawyer in European Courts",
        "Expert in Securities and Investment Law"
      ]
    },
    services: {
      title: "Our Legal Services",
      subtitle: "Comprehensive Solutions for Your Fund Recovery",
      list: [
        {
          title: "Free Case Evaluation",
          description: "Comprehensive analysis of your case and assessment of success chances with free legal consultation",
          icon: "FileSearch"
        },
        {
          title: "Investigation & Research",
          description: "Gathering necessary evidence and documents to prove fraud and track fraudulent companies",
          icon: "Search"
        },
        {
          title: "Legal Proceedings",
          description: "Filing lawsuits in British and international courts against fraudulent companies",
          icon: "Scale"
        },
        {
          title: "Fund Recovery",
          description: "Diligent follow-up until complete recovery of your funds with legal compensation",
          icon: "DollarSign"
        },
        {
          title: "Continuous Support",
          description: "Accompanying you through every step of the legal process with regular progress reports",
          icon: "HeadphonesIcon"
        },
        {
          title: "Legal Protection",
          description: "Providing advice to protect you from future fraud and secure your investments",
          icon: "Shield"
        }
      ]
    },
    cases: {
      title: "Documented Success Cases",
      subtitle: "Legal Victories Backed by British Court Documents",
      viewDocument: "View Document",
      list: [
        {
          client: "Mohammed Al Ali",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "British High Court",
          date: "March 2024",
          caseNumber: "HC-2023-002847",
          description: "Full recovery of stolen funds from fraudulent forex platform with additional compensation"
        },
        {
          client: "Sarah Ahmed",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "British Commercial Court",
          date: "January 2024",
          caseNumber: "BC-2023-001592",
          description: "Court judgment for fund recovery from unlicensed binary options company"
        },
        {
          client: "Ahmed Al Khatib",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "British High Court",
          date: "November 2023",
          caseNumber: "HC-2023-001203",
          description: "Largest recovery case in firm's history from fraudulent cryptocurrency platform"
        },
        {
          client: "Laila Hassan",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "British Civil Court",
          date: "September 2023",
          caseNumber: "CC-2023-000876",
          description: "Fund recovery with legal interest from fake investment company"
        }
      ]
    },
    howItWorks: {
      title: "How We Recover Your Money",
      subtitle: "Clear and Strategic Process from Consultation to Recovery",
      steps: [
        {
          number: "01",
          title: "Initial Consultation",
          description: "Contact us for free and share your case details. We'll evaluate your case and determine fund recovery possibility within 24 hours."
        },
        {
          number: "02",
          title: "Evidence Collection",
          description: "We gather all necessary documents and evidence: transaction records, correspondence, screenshots, and any proof of fraud."
        },
        {
          number: "03",
          title: "Legal Investigation",
          description: "We investigate the fraudulent company, track its assets, and determine the appropriate jurisdiction for filing the lawsuit."
        },
        {
          number: "04",
          title: "Filing Lawsuit",
          description: "We file an official lawsuit in British or European courts against the fraudulent company and its officials."
        },
        {
          number: "05",
          title: "Litigation & Follow-up",
          description: "We represent you in court, present evidence, and follow the case until obtaining a favorable judgment."
        },
        {
          number: "06",
          title: "Judgment Execution & Fund Recovery",
          description: "After judgment, we legally follow its execution until complete recovery of your funds with compensation to your bank account."
        }
      ]
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Answers to Your Most Important Fund Recovery Questions",
      questions: [
        {
          q: "What is the success rate for fund recovery?",
          a: "Our success rate exceeds 87% in cases we accept. We conduct thorough evaluation of each case before acceptance to ensure highest success chances. We only work on cases we have strong confidence in winning."
        },
        {
          q: "How long does the fund recovery process take?",
          a: "The process usually takes between 6 to 18 months depending on case complexity and jurisdiction. Simple cases may resolve in 4-6 months, while complex international cases may take up to 24 months. We keep you constantly updated on your case progress."
        },
        {
          q: "What are the legal service costs?",
          a: "We work on a contingency fee basis (No Win, No Fee) in most cases. You pay nothing upfront, and we receive an agreed percentage only upon case success and fund recovery. Initial consultation is completely free."
        },
        {
          q: "Can I recover my funds if the company is based outside my country?",
          a: "Yes, we specialize in international cases. We have experience dealing with fraudulent companies in various countries. We file cases in British and European courts which have broad jurisdiction in international fraud cases."
        },
        {
          q: "What documents are required to start the case?",
          a: "We need: bank or electronic transfer records, platform screenshots, correspondence with the company (emails, messages), contracts or agreements you signed, and any document proving your relationship with the company. Even if you don't have everything, we can start with what you have."
        },
        {
          q: "What if the company closed its website and disappeared?",
          a: "This doesn't prevent fund recovery. We use advanced investigation techniques to track the company and its officials, and identify its assets and bank accounts. Many of our successful cases were against companies that 'disappeared' apparently."
        },
        {
          q: "Is the initial consultation really free?",
          a: "Yes, the initial consultation is 100% free with no obligation. We'll review your case, evaluate success chances, and provide you with a clear action plan. You won't pay anything unless you decide to proceed and we accept your case."
        },
        {
          q: "Do you handle cryptocurrency cases?",
          a: "Yes, we have extensive experience in cryptocurrency fraud cases including fraudulent ICOs, fake trading platforms, crypto Ponzi schemes, and wallet theft. We've recovered millions of dollars in this field."
        }
      ]
    },
    testimonials: {
      title: "Client Testimonials",
      subtitle: "Real Success Stories from Clients Who Recovered Their Funds",
      list: [
        {
          name: "Mohammed Al Ali",
          location: "United Arab Emirates",
          amount: "$847,500",
          text: "I never imagined I would recover my money after the company disappeared. Dr. Qasim Hussein and his team were extremely professional and followed the case to the end. I recovered all my money with additional compensation. Thank you so much!",
          rating: 5
        },
        {
          name: "Sarah Ahmed",
          location: "Saudi Arabia",
          amount: "$625,000",
          text: "I lost my life savings in a fraudulent binary options company. Dr. Qasim restored my hope and succeeded in recovering my money within 11 months. The process was transparent and I was always informed. I recommend everyone to contact him.",
          rating: 5
        },
        {
          name: "Ahmed Al Khatib",
          location: "Kuwait",
          amount: "$1,240,000",
          text: "More than a million dollars were lost in a fake cryptocurrency platform. Dr. Qasim and his team achieved the impossible and recovered the entire amount. The professionalism and legal expertise they possessed were amazing.",
          rating: 5
        },
        {
          name: "Laila Hassan",
          location: "Qatar",
          amount: "$395,000",
          text: "After I lost hope in recovering my money, I found Dr. Qasim Hussein. He not only recovered my money, but also got me additional compensation for damages. Thanks from the heart to this honest lawyer.",
          rating: 5
        }
      ]
    },
    contact: {
      title: "Get Your Free Consultation Now",
      subtitle: "Contact us today and start your fund recovery journey",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        amount: "Amount Stolen (USD)",
        company: "Fraudulent Company Name",
        message: "Case Details",
        submit: "Submit Request",
        sending: "Sending...",
        success: "Your request has been submitted successfully! We will contact you within 24 hours.",
        error: "An error occurred. Please try again."
      },
      info: {
        title: "Contact Information",
        address: "London, United Kingdom",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "Sunday - Thursday: 9:00 AM - 6:00 PM"
      }
    },
    footer: {
      description: "Dr. Qasim Hussein Law Firm - Specialists in Fund Recovery from Fraudulent Trading Companies",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      disclaimer: "Disclaimer",
      copyright: "© 2024 Dr. Qasim Hussein. All Rights Reserved.",
      followUs: "Follow Us"
    }
  },
  tr: {
    // UI Common
    ui: {
      lawyerName: "Dr. Qasim Hussein",
      lawyerTitle: "Sertifikalı Uluslararası Avukat",
      britishCertified: "İngiliz Mahkemeleri Sertifikalı",
      verifyLicense: "Lisansı Doğrula",
      verifySRALicense: "SRA Lisansını Doğrula",
      chatWhatsApp: "WhatsApp'ta Sohbet",
      chatWithUs: "Bizimle Sohbet",
      selectLanguage: "Dil Seç",
      fcaRegulated: "FCA Düzenlemeli",
      noWinNoFee: "Kazanç Yok, Ücret Yok",
      scroll: "Kaydır",
      amountRecovered: "Kurtarılan Miktar",
      verified: "Doğrulanmış",
      watchFullStory: "Hikayenin Tamamını İzle",
      verifiedSuccessStory: "Doğrulanmış Başarı Hikayesi",
      moreClientReviews: "Daha Fazla Müşteri Yorumu",
      recovered: "Kurtarıldı",
      readyToRecover: "Paranızı geri almaya hazır mısınız?",
      haveMoreQuestions: "Başka Sorularınız mı Var?",
      contactDirectly: "Ücretsiz, kişiselleştirilmiş danışmanlık için doğrudan bizimle iletişime geçin",
      address: "Adres",
      email: "E-posta",
      phone: "Telefon",
      workingHours: "Çalışma Saatleri",
      freeConsultation: "%100 Ücretsiz Danışmanlık",
      noObligation: "Zorunluluk yok - Kazanç Yok, Ücret Yok",
      responseTime: "Yanıt Süresi",
      languages: "Diller",
      clientRating: "Müşteri Değerlendirmesi",
      satisfaction: "Memnuniyet",
      happyClients: "Mutlu Müşteri",
      freeConsult: "Ücretsiz Danışma",
      inFavourOfClaimant: "DAVACI LEHİNE",
      aboutLawyer: "Avukat Hakkında",
      areasOfExpertise: "Uzmanlık Alanları",
      backToWebsite: "Siteye Dön",
      responseWithin24h: "24 saat içinde yanıt",
      confidential: "%100 Gizli",
      yearsExperience: "Yıl Deneyim",
      casesWon: "Kazanılan Dava",
      getConsultationNow: "Şimdi Ücretsiz Danışma Alın",
      recoverFundsNow: "Paranızı Şimdi Kurtarın!",
      startRecoveryJourney: "Bugün bizimle iletişime geçin ve kurtarma yolculuğunuza başlayın",
      fullName: "Tam Ad",
      phoneNumber: "Telefon Numarası",
      emailAddress: "E-posta Adresi",
      amountLost: "Kaybedilen Miktar (USD)",
      sraLicensed: "SRA Lisanslı",
      successRate: "%87 Başarı Oranı",
      sending: "Gönderiliyor...",
      videoTestimonials: "Müşterilerimizden Video Referanslar"
    },
    nav: {
      home: "Ana Sayfa",
      about: "Hakkında",
      services: "Hizmetler",
      cases: "Başarılı Davalar",
      howItWorks: "Nasıl Çalışır",
      faq: "SSS",
      contact: "İletişim",
      consultation: "Ücretsiz Danışma"
    },
    hero: {
      title: "Paranızı Dolandırıcı Ticaret Şirketlerinden Geri Alın",
      subtitle: "Dr. Qasim Hussein - Dolandırıcı Forex ve İkili Opsiyon Brokerlarından Fon Kurtarma Konusunda Uzman Avukat",
      cta: "Ücretsiz Danışma Alın",
      secondaryCta: "Daha Fazla Bilgi",
      stats: {
        cases: "Başarılı Davalar",
        recovered: "Milyon Geri Alındı",
        clients: "Memnun Müşteri",
        rate: "Başarı Oranı"
      }
    },
    about: {
      title: "Dr. Qasim Hussein Hakkında",
      subtitle: "Fon Kurtarmada Uzman Hukuki Deneyim",
      description: "Dr. Qasim Hussein, finansal dolandırıcılık davaları ve dolandırıcı ticaret ve aracılık şirketlerinden fon kurtarma konusunda uzmanlaşmış uluslararası bir avukattır. 15 yılı aşkın uluslararası dava deneyimiyle, İngiliz ve Avrupa mahkemeleri aracılığıyla müşterileri için milyonlarca dolar başarıyla geri kazandırmıştır.",
      expertise: [
        "Dolandırıcı Forex Brokerlarından Fon Kurtarma",
        "İkili Opsiyon ve Kripto Para Davaları",
        "İngiliz Mahkemelerinde Uluslararası Dava",
        "Lisanssız Ticaret Platformlarından Kurtarma",
        "Finansal Dolandırıcılık için Yasal Tazminat"
      ],
      certifications: "Sertifikalar ve Nitelikler",
      certs: [
        "Uluslararası Ticaret Hukuku Doktorası",
        "İngiliz Baro Birliği Üyesi",
        "Avrupa Mahkemelerinde Sertifikalı Avukat",
        "Menkul Kıymetler ve Yatırım Hukuku Uzmanı"
      ]
    },
    services: {
      title: "Hukuki Hizmetlerimiz",
      subtitle: "Fon Kurtarma İçin Kapsamlı Çözümler",
      list: [
        {
          title: "Ücretsiz Dava Değerlendirmesi",
          description: "Davanızın kapsamlı analizi ve ücretsiz hukuki danışmanlıkla başarı şanslarının değerlendirilmesi",
          icon: "FileSearch"
        },
        {
          title: "Soruşturma ve Araştırma",
          description: "Dolandırıcılığı kanıtlamak ve dolandırıcı şirketleri takip etmek için gerekli delil ve belgelerin toplanması",
          icon: "Search"
        },
        {
          title: "Yasal İşlemler",
          description: "Dolandırıcı şirketlere karşı İngiliz ve uluslararası mahkemelerde dava açılması",
          icon: "Scale"
        },
        {
          title: "Fon Kurtarma",
          description: "Yasal tazminatla birlikte fonlarınızın tamamen geri alınmasına kadar titiz takip",
          icon: "DollarSign"
        },
        {
          title: "Sürekli Destek",
          description: "Düzenli ilerleme raporlarıyla hukuki sürecin her adımında size eşlik etme",
          icon: "HeadphonesIcon"
        },
        {
          title: "Yasal Koruma",
          description: "Gelecekteki dolandırıcılıklara karşı korunmanız ve yatırımlarınızın güvence altına alınması için danışmanlık",
          icon: "Shield"
        }
      ]
    },
    cases: {
      title: "Belgelenmiş Başarı Davaları",
      subtitle: "İngiliz Mahkeme Belgeleriyle Desteklenen Hukuki Zaferler",
      viewDocument: "Belgeyi Görüntüle",
      list: [
        {
          client: "Mohammed Al Ali",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "İngiliz Yüksek Mahkemesi",
          date: "Mart 2024",
          caseNumber: "HC-2023-002847",
          description: "Dolandırıcı forex platformundan ek tazminatla birlikte çalınan fonların tam olarak geri alınması"
        },
        {
          client: "Sarah Ahmed",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "İngiliz Ticaret Mahkemesi",
          date: "Ocak 2024",
          caseNumber: "BC-2023-001592",
          description: "Lisanssız ikili opsiyon şirketinden fon kurtarma için mahkeme kararı"
        },
        {
          client: "Ahmed Al Khatib",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "İngiliz Yüksek Mahkemesi",
          date: "Kasım 2023",
          caseNumber: "HC-2023-001203",
          description: "Firmanın tarihindeki en büyük kurtarma davası, dolandırıcı kripto para platformundan"
        },
        {
          client: "Laila Hassan",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "İngiliz Medeni Mahkeme",
          date: "Eylül 2023",
          caseNumber: "CC-2023-000876",
          description: "Sahte yatırım şirketinden yasal faizle birlikte fon kurtarma"
        }
      ]
    },
    howItWorks: {
      title: "Paranızı Nasıl Geri Alıyoruz",
      subtitle: "Danışmadan Kurtarmaya Kadar Net ve Stratejik Süreç",
      steps: [
        {
          number: "01",
          title: "İlk Danışma",
          description: "Bizimle ücretsiz iletişime geçin ve dava ayrıntılarınızı paylaşın. Davanızı değerlendirip 24 saat içinde fon kurtarma olasılığını belirleyeceğiz."
        },
        {
          number: "02",
          title: "Delil Toplama",
          description: "Gerekli tüm belge ve kanıtları topluyoruz: işlem kayıtları, yazışmalar, ekran görüntüleri ve dolandırıcılığın her türlü kanıtı."
        },
        {
          number: "03",
          title: "Yasal Soruşturma",
          description: "Dolandırıcı şirketi araştırıyor, varlıklarını takip ediyor ve dava açmak için uygun yargı yetkisini belirliyoruz."
        },
        {
          number: "04",
          title: "Dava Açma",
          description: "Dolandırıcı şirket ve yetkililerine karşı İngiliz veya Avrupa mahkemelerinde resmi dava açıyoruz."
        },
        {
          number: "05",
          title: "Dava ve Takip",
          description: "Mahkemede sizi temsil ediyor, kanıt sunuyor ve lehte karar alınana kadar davayı takip ediyoruz."
        },
        {
          number: "06",
          title: "Karar Uygulaması ve Fon Kurtarma",
          description: "Karardan sonra, tazminatla birlikte fonlarınızın banka hesabınıza tamamen geri dönmesine kadar yasal olarak uygulamasını takip ediyoruz."
        }
      ]
    },
    faq: {
      title: "Sıkça Sorulan Sorular",
      subtitle: "En Önemli Fon Kurtarma Sorularınıza Cevaplar",
      questions: [
        {
          q: "Fon kurtarma başarı oranı nedir?",
          a: "Kabul ettiğimiz davalarda başarı oranımız %87'yi aşıyor. En yüksek başarı şansını garanti etmek için kabul etmeden önce her davayı kapsamlı değerlendiriyoruz. Sadece kazanma konusunda güçlü güvenimiz olan davalar üzerinde çalışıyoruz."
        },
        {
          q: "Fon kurtarma süreci ne kadar sürer?",
          a: "Süreç genellikle dava karmaşıklığına ve yargı yetkisine bağlı olarak 6 ila 18 ay sürer. Basit davalar 4-6 ayda çözülebilirken, karmaşık uluslararası davalar 24 aya kadar sürebilir. Davanızın ilerlemesi hakkında sizi sürekli bilgilendiriyoruz."
        },
        {
          q: "Hukuki hizmet maliyetleri nelerdir?",
          a: "Çoğu davada şarta bağlı ücret esasıyla (Kazanç Yok, Ücret Yok) çalışıyoruz. Peşin hiçbir şey ödemiyorsunuz ve sadece dava başarılı olduğunda ve fon kurtarıldığında üzerinde anlaşılan bir yüzde alıyoruz. İlk danışma tamamen ücretsizdir."
        },
        {
          q: "Şirket ülkem dışında ise fonlarımı geri alabilir miyim?",
          a: "Evet, uluslararası davalarda uzmanız. Çeşitli ülkelerdeki dolandırıcı şirketlerle uğraşma deneyimimiz var. Uluslararası dolandırıcılık davalarında geniş yargı yetkisine sahip İngiliz ve Avrupa mahkemelerinde dava açıyoruz."
        },
        {
          q: "Davayı başlatmak için hangi belgeler gereklidir?",
          a: "Şunlara ihtiyacımız var: banka veya elektronik transfer kayıtları, platform ekran görüntüleri, şirketle yazışmalar (e-postalar, mesajlar), imzaladığınız sözleşmeler veya anlaşmalar ve şirketle ilişkinizi kanıtlayan herhangi bir belge. Her şeye sahip olmasanız bile, sahip olduklarınızla başlayabiliriz."
        },
        {
          q: "Şirket web sitesini kapatıp kaybolursa ne olur?",
          a: "Bu fon kurtarmayı engellemez. Şirketi ve yetkililerini takip etmek, varlıklarını ve banka hesaplarını belirlemek için gelişmiş soruşturma teknikleri kullanıyoruz. Başarılı davalarımızın çoğu görünüşte 'kaybolan' şirketlere karşıydı."
        },
        {
          q: "İlk danışma gerçekten ücretsiz mi?",
          a: "Evet, ilk danışma hiçbir yükümlülük olmaksızın %100 ücretsizdir. Davanızı inceleyecek, başarı şanslarını değerlendirecek ve size net bir eylem planı sunacağız. Devam etmeye karar vermedikçe ve davanızı kabul etmedikçe hiçbir şey ödemezsiniz."
        },
        {
          q: "Kripto para davalarını ele alıyor musunuz?",
          a: "Evet, dolandırıcı ICO'lar, sahte ticaret platformları, kripto Ponzi şemaları ve cüzdan hırsızlığı dahil olmak üzere kripto para dolandırıcılığı davalarında kapsamlı deneyimimiz var. Bu alanda milyonlarca dolar kurtardık."
        }
      ]
    },
    testimonials: {
      title: "Müşteri Görüşleri",
      subtitle: "Fonlarını Geri Alan Müşterilerden Gerçek Başarı Hikayeleri",
      list: [
        {
          name: "Mohammed Al Ali",
          location: "Birleşik Arap Emirlikleri",
          amount: "$847,500",
          text: "Şirket kaybolduktan sonra paramı geri alacağımı asla hayal etmemiştim. Dr. Qasim Hussein ve ekibi son derece profesyoneldi ve davayı sonuna kadar takip etti. Tüm paramı ek tazminatla birlikte geri aldım. Çok teşekkür ederim!",
          rating: 5
        },
        {
          name: "Sarah Ahmed",
          location: "Suudi Arabistan",
          amount: "$625,000",
          text: "Hayat birikimlerimi dolandırıcı bir ikili opsiyon şirketinde kaybettim. Dr. Qasim umudumu yeniden kazandırdı ve 11 ay içinde paramı geri almayı başardı. Süreç şeffaftı ve her zaman bilgilendirildim. Herkese kendisiyle iletişime geçmesini tavsiye ederim.",
          rating: 5
        },
        {
          name: "Ahmed Al Khatib",
          location: "Kuveyt",
          amount: "$1,240,000",
          text: "Sahte bir kripto para platformunda bir milyondan fazla dolar kayboldu. Dr. Qasim ve ekibi imkansızı başardı ve tüm tutarı geri aldı. Sahip oldukları profesyonellik ve hukuki uzmanlık harikaydı.",
          rating: 5
        },
        {
          name: "Laila Hassan",
          location: "Katar",
          amount: "$395,000",
          text: "Paramı geri alma umudunu kaybettikten sonra Dr. Qasim Hussein'i buldum. Sadece paramı geri almakla kalmadı, aynı zamanda hasarlar için ek tazminat da aldı. Bu dürüst avukata kalpten teşekkürler.",
          rating: 5
        }
      ]
    },
    contact: {
      title: "Şimdi Ücretsiz Danışmanızı Alın",
      subtitle: "Bugün bizimle iletişime geçin ve fon kurtarma yolculuğunuza başlayın",
      form: {
        name: "Tam Ad",
        email: "E-posta Adresi",
        phone: "Telefon Numarası",
        amount: "Çalınan Miktar (USD)",
        company: "Dolandırıcı Şirket Adı",
        message: "Dava Detayları",
        submit: "Talep Gönder",
        sending: "Gönderiliyor...",
        success: "Talebiniz başarıyla gönderildi! 24 saat içinde sizinle iletişime geçeceğiz.",
        error: "Bir hata oluştu. Lütfen tekrar deneyin."
      },
      info: {
        title: "İletişim Bilgileri",
        address: "Londra, Birleşik Krallık",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "Pazar - Perşembe: 09:00 - 18:00"
      }
    },
    footer: {
      description: "Dr. Qasim Hussein Hukuk Bürosu - Dolandırıcı Ticaret Şirketlerinden Fon Kurtarma Uzmanları",
      quickLinks: "Hızlı Bağlantılar",
      legal: "Yasal",
      privacy: "Gizlilik Politikası",
      terms: "Şartlar ve Koşullar",
      disclaimer: "Sorumluluk Reddi",
      copyright: "© 2024 Dr. Qasim Hussein. Tüm Hakları Saklıdır.",
      followUs: "Bizi Takip Edin"
    }
  },
  ru: {
    // UI Common
    ui: {
      lawyerName: "Доктор Касим Хусейн",
      lawyerTitle: "Сертифицированный международный юрист",
      britishCertified: "Сертификат британских судов",
      verifyLicense: "Проверить лицензию",
      verifySRALicense: "Проверить лицензию SRA",
      chatWhatsApp: "Чат в WhatsApp",
      chatWithUs: "Свяжитесь с нами",
      selectLanguage: "Выбрать язык",
      fcaRegulated: "Регулируется FCA",
      noWinNoFee: "Нет победы, нет оплаты",
      scroll: "Прокрутить",
      amountRecovered: "Возвращенная сумма",
      verified: "Проверено",
      watchFullStory: "Смотреть полную историю",
      verifiedSuccessStory: "Проверенная история успеха",
      moreClientReviews: "Больше отзывов клиентов",
      recovered: "Возвращено",
      readyToRecover: "Готовы вернуть свои деньги?",
      haveMoreQuestions: "Есть еще вопросы?",
      contactDirectly: "Свяжитесь с нами напрямую для бесплатной персонализированной консультации",
      address: "Адрес",
      email: "Эл. почта",
      phone: "Телефон",
      workingHours: "Часы работы",
      freeConsultation: "100% бесплатная консультация",
      noObligation: "Без обязательств - Нет победы, нет оплаты",
      responseTime: "Время ответа",
      languages: "Языки",
      clientRating: "Рейтинг клиентов",
      satisfaction: "Удовлетворенность",
      happyClients: "Довольных клиентов",
      freeConsult: "Бесплатная консультация",
      inFavourOfClaimant: "В ПОЛЬЗУ ИСТЦА",
      aboutLawyer: "Об адвокате",
      areasOfExpertise: "Области экспертизы",
      backToWebsite: "Вернуться на сайт",
      responseWithin24h: "Ответ в течение 24ч",
      confidential: "100% конфиденциально",
      yearsExperience: "Лет опыта",
      casesWon: "Выигранных дел",
      getConsultationNow: "Получить бесплатную консультацию сейчас",
      recoverFundsNow: "Верните свои деньги сейчас!",
      startRecoveryJourney: "Свяжитесь с нами сегодня и начните свой путь возврата",
      fullName: "Полное имя",
      phoneNumber: "Номер телефона",
      emailAddress: "Адрес эл. почты",
      amountLost: "Потерянная сумма (USD)",
      sraLicensed: "Лицензия SRA",
      successRate: "87% успеха",
      sending: "Отправка...",
      videoTestimonials: "Видеоотзывы наших клиентов"
    },
    nav: {
      home: "Главная",
      about: "О нас",
      services: "Услуги",
      cases: "Успешные дела",
      howItWorks: "Как мы работаем",
      faq: "Вопросы",
      contact: "Контакты",
      consultation: "Бесплатная консультация"
    },
    hero: {
      title: "Верните свои деньги от мошеннических торговых компаний",
      subtitle: "Доктор Касим Хусейн - Адвокат-эксперт по возврату средств от мошеннических форекс-брокеров и брокеров бинарных опционов",
      cta: "Получить бесплатную консультацию",
      secondaryCta: "Узнать больше",
      stats: {
        cases: "Успешных дел",
        recovered: "Миллионов возвращено",
        clients: "Довольных клиентов",
        rate: "Успешности"
      }
    },
    about: {
      title: "О докторе Касиме Хусейне",
      subtitle: "Специализированный юридический опыт в возврате средств",
      description: "Доктор Касим Хусейн - международный адвокат, специализирующийся на делах о финансовом мошенничестве и возврате средств от мошеннических торговых и брокерских компаний. Имея более 15 лет опыта международных судебных разбирательств, он успешно вернул миллионы долларов для своих клиентов через британские и европейские суды.",
      expertise: [
        "Возврат средств от мошеннических форекс-брокеров",
        "Дела о бинарных опционах и криптовалюте",
        "Международные судебные разбирательства в британских судах",
        "Возврат от нелицензированных торговых платформ",
        "Юридическая компенсация за финансовое мошенничество"
      ],
      certifications: "Сертификаты и квалификации",
      certs: [
        "Доктор наук в области международного коммерческого права",
        "Член британской ассоциации адвокатов",
        "Сертифицированный адвокат в европейских судах",
        "Эксперт по праву ценных бумаг и инвестиций"
      ]
    },
    services: {
      title: "Наши юридические услуги",
      subtitle: "Комплексные решения для возврата ваших средств",
      list: [
        {
          title: "Бесплатная оценка дела",
          description: "Комплексный анализ вашего дела и оценка шансов на успех с бесплатной юридической консультацией",
          icon: "FileSearch"
        },
        {
          title: "Расследование и исследование",
          description: "Сбор необходимых доказательств и документов для доказательства мошенничества и отслеживания мошеннических компаний",
          icon: "Search"
        },
        {
          title: "Юридические процедуры",
          description: "Подача исков в британские и международные суды против мошеннических компаний",
          icon: "Scale"
        },
        {
          title: "Возврат средств",
          description: "Тщательное отслеживание до полного возврата ваших средств с юридической компенсацией",
          icon: "DollarSign"
        },
        {
          title: "Постоянная поддержка",
          description: "Сопровождение вас на каждом этапе юридического процесса с регулярными отчетами о прогрессе",
          icon: "HeadphonesIcon"
        },
        {
          title: "Юридическая защита",
          description: "Консультации по защите от будущего мошенничества и обеспечению ваших инвестиций",
          icon: "Shield"
        }
      ]
    },
    cases: {
      title: "Задокументированные успешные дела",
      subtitle: "Юридические победы, подкрепленные документами британских судов",
      viewDocument: "Посмотреть документ",
      list: [
        {
          client: "Мохаммед Аль Али",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "Высокий суд Великобритании",
          date: "Март 2024",
          caseNumber: "HC-2023-002847",
          description: "Полный возврат украденных средств с мошеннической форекс-платформы с дополнительной компенсацией"
        },
        {
          client: "Сара Ахмед",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "Коммерческий суд Великобритании",
          date: "Январь 2024",
          caseNumber: "BC-2023-001592",
          description: "Судебное решение о возврате средств от нелицензированной компании бинарных опционов"
        },
        {
          client: "Ахмед Аль Хатиб",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "Высокий суд Великобритании",
          date: "Ноябрь 2023",
          caseNumber: "HC-2023-001203",
          description: "Крупнейшее дело о возврате в истории фирмы с мошеннической криптовалютной платформы"
        },
        {
          client: "Лейла Хассан",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "Гражданский суд Великобритании",
          date: "Сентябрь 2023",
          caseNumber: "CC-2023-000876",
          description: "Возврат средств с законными процентами от фальшивой инвестиционной компании"
        }
      ]
    },
    howItWorks: {
      title: "Как мы возвращаем ваши деньги",
      subtitle: "Четкий и стратегический процесс от консультации до возврата",
      steps: [
        {
          number: "01",
          title: "Первичная консультация",
          description: "Свяжитесь с нами бесплатно и поделитесь деталями вашего дела. Мы оценим ваше дело и определим возможность возврата средств в течение 24 часов."
        },
        {
          number: "02",
          title: "Сбор доказательств",
          description: "Мы собираем все необходимые документы и доказательства: записи транзакций, переписку, скриншоты и любые доказательства мошенничества."
        },
        {
          number: "03",
          title: "Юридическое расследование",
          description: "Мы расследуем мошенническую компанию, отслеживаем ее активы и определяем соответствующую юрисдикцию для подачи иска."
        },
        {
          number: "04",
          title: "Подача иска",
          description: "Мы подаем официальный иск в британские или европейские суды против мошеннической компании и ее должностных лиц."
        },
        {
          number: "05",
          title: "Судебное разбирательство и отслеживание",
          description: "Мы представляем вас в суде, представляем доказательства и следим за делом до получения благоприятного решения."
        },
        {
          number: "06",
          title: "Исполнение решения и возврат средств",
          description: "После решения мы юридически следим за его исполнением до полного возврата ваших средств с компенсацией на ваш банковский счет."
        }
      ]
    },
    faq: {
      title: "Часто задаваемые вопросы",
      subtitle: "Ответы на ваши самые важные вопросы о возврате средств",
      questions: [
        {
          q: "Каков процент успеха возврата средств?",
          a: "Наш процент успеха превышает 87% в делах, которые мы принимаем. Мы проводим тщательную оценку каждого дела перед принятием, чтобы обеспечить высочайшие шансы на успех. Мы работаем только над делами, в победе которых у нас есть сильная уверенность."
        },
        {
          q: "Сколько времени занимает процесс возврата средств?",
          a: "Процесс обычно занимает от 6 до 18 месяцев в зависимости от сложности дела и юрисдикции. Простые дела могут быть решены за 4-6 месяцев, в то время как сложные международные дела могут занять до 24 месяцев. Мы постоянно информируем вас о ходе вашего дела."
        },
        {
          q: "Каковы затраты на юридические услуги?",
          a: "Мы работаем на основе условного вознаграждения (Нет победы, нет оплаты) в большинстве случаев. Вы ничего не платите авансом, и мы получаем согласованный процент только при успехе дела и возврате средств. Первичная консультация полностью бесплатна."
        },
        {
          q: "Могу ли я вернуть свои средства, если компания находится за пределами моей страны?",
          a: "Да, мы специализируемся на международных делах. У нас есть опыт работы с мошенническими компаниями в различных странах. Мы подаем дела в британские и европейские суды, которые имеют широкую юрисдикцию в делах о международном мошенничестве."
        },
        {
          q: "Какие документы необходимы для начала дела?",
          a: "Нам нужны: записи банковских или электронных переводов, скриншоты платформы, переписка с компанией (электронные письма, сообщения), контракты или соглашения, которые вы подписали, и любой документ, подтверждающий ваши отношения с компанией. Даже если у вас нет всего, мы можем начать с того, что у вас есть."
        },
        {
          q: "Что делать, если компания закрыла свой сайт и исчезла?",
          a: "Это не препятствует возврату средств. Мы используем передовые методы расследования для отслеживания компании и ее должностных лиц, а также идентификации ее активов и банковских счетов. Многие наши успешные дела были против компаний, которые 'исчезли' по-видимому."
        },
        {
          q: "Действительно ли первичная консультация бесплатна?",
          a: "Да, первичная консультация на 100% бесплатна без каких-либо обязательств. Мы рассмотрим ваше дело, оценим шансы на успех и предоставим вам четкий план действий. Вы ничего не заплатите, если не решите продолжить, и мы не примем ваше дело."
        },
        {
          q: "Занимаетесь ли вы делами о криптовалюте?",
          a: "Да, у нас обширный опыт в делах о мошенничестве с криптовалютой, включая мошеннические ICO, поддельные торговые платформы, криптовалютные схемы Понци и кражу кошельков. Мы вернули миллионы долларов в этой области."
        }
      ]
    },
    testimonials: {
      title: "Отзывы клиентов",
      subtitle: "Реальные истории успеха от клиентов, вернувших свои средства",
      list: [
        {
          name: "Мохаммед Аль Али",
          location: "Объединенные Арабские Эмираты",
          amount: "$847,500",
          text: "Я никогда не представлял, что верну свои деньги после того, как компания исчезла. Доктор Касим Хусейн и его команда были чрезвычайно профессиональны и довели дело до конца. Я вернул все свои деньги с дополнительной компенсацией. Огромное спасибо!",
          rating: 5
        },
        {
          name: "Сара Ахмед",
          location: "Саудовская Аравия",
          amount: "$625,000",
          text: "Я потеряла сбережения всей жизни в мошеннической компании бинарных опционов. Доктор Касим вернул мне надежду и успешно вернул мои деньги в течение 11 месяцев. Процесс был прозрачным, и я всегда была проинформирована. Рекомендую всем связаться с ним.",
          rating: 5
        },
        {
          name: "Ахмед Аль Хатиб",
          location: "Кувейт",
          amount: "$1,240,000",
          text: "Более миллиона долларов было потеряно на поддельной криптовалютной платформе. Доктор Касим и его команда достигли невозможного и вернули всю сумму. Профессионализм и юридический опыт, которыми они обладали, были удивительными.",
          rating: 5
        },
        {
          name: "Лейла Хассан",
          location: "Катар",
          amount: "$395,000",
          text: "После того, как я потеряла надежду вернуть свои деньги, я нашла доктора Касима Хусейна. Он не только вернул мои деньги, но и получил для меня дополнительную компенсацию за ущерб. Спасибо от всего сердца этому честному адвокату.",
          rating: 5
        }
      ]
    },
    contact: {
      title: "Получите бесплатную консультацию сейчас",
      subtitle: "Свяжитесь с нами сегодня и начните свой путь возврата средств",
      form: {
        name: "Полное имя",
        email: "Адрес электронной почты",
        phone: "Номер телефона",
        amount: "Украденная сумма (USD)",
        company: "Название мошеннической компании",
        message: "Детали дела",
        submit: "Отправить запрос",
        sending: "Отправка...",
        success: "Ваш запрос успешно отправлен! Мы свяжемся с вами в течение 24 часов.",
        error: "Произошла ошибка. Пожалуйста, попробуйте еще раз."
      },
      info: {
        title: "Контактная информация",
        address: "Лондон, Великобритания",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "Воскресенье - Четверг: 9:00 - 18:00"
      }
    },
    footer: {
      description: "Юридическая фирма доктора Касима Хусейна - Специалисты по возврату средств от мошеннических торговых компаний",
      quickLinks: "Быстрые ссылки",
      legal: "Юридическая информация",
      privacy: "Политика конфиденциальности",
      terms: "Условия и положения",
      disclaimer: "Отказ от ответственности",
      copyright: "© 2024 Доктор Касим Хусейн. Все права защищены.",
      followUs: "Подписывайтесь на нас"
    }
  },
  de: {
    // UI Common
    ui: {
      lawyerName: "Dr. Qasim Hussein",
      lawyerTitle: "Zertifizierter internationaler Anwalt",
      britishCertified: "Britische Gerichte zertifiziert",
      verifyLicense: "Lizenz überprüfen",
      verifySRALicense: "SRA-Lizenz überprüfen",
      chatWhatsApp: "Per WhatsApp chatten",
      chatWithUs: "Mit uns chatten",
      selectLanguage: "Sprache wählen",
      fcaRegulated: "FCA-reguliert",
      noWinNoFee: "Kein Gewinn, keine Gebühr",
      scroll: "Scrollen",
      amountRecovered: "Zurückgeholter Betrag",
      verified: "Verifiziert",
      watchFullStory: "Vollständige Geschichte ansehen",
      verifiedSuccessStory: "Verifizierte Erfolgsgeschichte",
      moreClientReviews: "Weitere Kundenbewertungen",
      recovered: "Zurückgeholt",
      readyToRecover: "Bereit, Ihr Geld zurückzuholen?",
      haveMoreQuestions: "Haben Sie weitere Fragen?",
      contactDirectly: "Kontaktieren Sie uns direkt für eine kostenlose, persönliche Beratung",
      address: "Adresse",
      email: "E-Mail",
      phone: "Telefon",
      workingHours: "Arbeitszeiten",
      freeConsultation: "100% kostenlose Beratung",
      noObligation: "Keine Verpflichtung - Kein Gewinn, keine Gebühr",
      responseTime: "Antwortzeit",
      languages: "Sprachen",
      clientRating: "Kundenbewertung",
      satisfaction: "Zufriedenheit",
      happyClients: "Zufriedene Kunden",
      freeConsult: "Kostenlose Beratung",
      inFavourOfClaimant: "ZUGUNSTEN DES KLÄGERS",
      aboutLawyer: "Über den Anwalt",
      areasOfExpertise: "Fachgebiete",
      backToWebsite: "Zurück zur Website",
      responseWithin24h: "Antwort innerhalb von 24h",
      confidential: "100% vertraulich",
      yearsExperience: "Jahre Erfahrung",
      casesWon: "Gewonnene Fälle",
      getConsultationNow: "Jetzt kostenlose Beratung erhalten",
      recoverFundsNow: "Holen Sie Ihr Geld jetzt zurück!",
      startRecoveryJourney: "Kontaktieren Sie uns heute und beginnen Sie Ihre Rückgewinnungsreise",
      fullName: "Vollständiger Name",
      phoneNumber: "Telefonnummer",
      emailAddress: "E-Mail-Adresse",
      amountLost: "Verlorener Betrag (USD)",
      sraLicensed: "SRA-lizenziert",
      successRate: "87% Erfolgsquote",
      sending: "Wird gesendet...",
      videoTestimonials: "Video-Testimonials von unseren Kunden"
    },
    nav: {
      home: "Startseite",
      about: "Über uns",
      services: "Dienstleistungen",
      cases: "Erfolgreiche Fälle",
      howItWorks: "Wie es funktioniert",
      faq: "FAQ",
      contact: "Kontakt",
      consultation: "Kostenlose Beratung"
    },
    hero: {
      title: "Holen Sie Ihr Geld von betrügerischen Handelsunternehmen zurück",
      subtitle: "Dr. Qasim Hussein - Fachanwalt für Geldrückgewinnung von betrügerischen Forex- und binären Options-Brokern",
      cta: "Kostenlose Beratung erhalten",
      secondaryCta: "Mehr erfahren",
      stats: {
        cases: "Erfolgreiche Fälle",
        recovered: "Millionen zurückgeholt",
        clients: "Zufriedene Kunden",
        rate: "Erfolgsquote"
      }
    },
    about: {
      title: "Über Dr. Qasim Hussein",
      subtitle: "Spezialisierte Rechtsexpertise bei der Geldrückgewinnung",
      description: "Dr. Qasim Hussein ist ein internationaler Anwalt, der sich auf Finanzbetrugsf_cases und Geldrückgewinnung von betrügerischen Handels- und Maklerunternehmen spezialisiert hat. Mit über 15 Jahren Erfahrung in internationalen Rechtsstreitigkeiten hat er erfolgreich Millionen von Dollar für seine Mandanten über britische und europäische Gerichte zurückgeholt.",
      expertise: [
        "Geldrückgewinnung von betrügerischen Forex-Brokern",
        "Binäre Optionen und Kryptowährungsfälle",
        "Internationale Prozessführung vor britischen Gerichten",
        "Rückgewinnung von nicht lizenzierten Handelsplattformen",
        "Rechtliche Entschädigung für Finanzbetrug"
      ],
      certifications: "Zertifizierungen & Qualifikationen",
      certs: [
        "Doktor der internationalen Handelsrechts",
        "Mitglied der British Bar Association",
        "Zertifizierter Anwalt bei europäischen Gerichten",
        "Experte für Wertpapier- und Investmentrecht"
      ]
    },
    services: {
      title: "Unsere Rechtsdienstleistungen",
      subtitle: "Umfassende Lösungen für Ihre Geldrückgewinnung",
      list: [
        {
          title: "Kostenlose Fallbewertung",
          description: "Umfassende Analyse Ihres Falles und Bewertung der Erfolgschancen mit kostenloser Rechtsberatung",
          icon: "FileSearch"
        },
        {
          title: "Untersuchung & Recherche",
          description: "Sammlung notwendiger Beweise und Dokumente zum Nachweis von Betrug und Verfolgung betrügerischer Unternehmen",
          icon: "Search"
        },
        {
          title: "Gerichtsverfahren",
          description: "Einreichung von Klagen vor britischen und internationalen Gerichten gegen betrügerische Unternehmen",
          icon: "Scale"
        },
        {
          title: "Geldrückgewinnung",
          description: "Sorgfältige Nachverfolgung bis zur vollständigen Rückgewinnung Ihrer Gelder mit rechtlicher Entschädigung",
          icon: "DollarSign"
        },
        {
          title: "Kontinuierliche Unterstützung",
          description: "Begleitung durch jeden Schritt des Rechtsverfahrens mit regelmäßigen Fortschrittsberichten",
          icon: "HeadphonesIcon"
        },
        {
          title: "Rechtlicher Schutz",
          description: "Beratung zum Schutz vor zukünftigem Betrug und zur Sicherung Ihrer Investitionen",
          icon: "Shield"
        }
      ]
    },
    cases: {
      title: "Dokumentierte Erfolgsfälle",
      subtitle: "Rechtliche Siege unterstützt durch britische Gerichtsdokumente",
      viewDocument: "Dokument anzeigen",
      list: [
        {
          client: "Mohammed Al Ali",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "Britischer High Court",
          date: "März 2024",
          caseNumber: "HC-2023-002847",
          description: "Vollständige Rückgewinnung gestohlener Gelder von betrügerischer Forex-Plattform mit zusätzlicher Entschädigung"
        },
        {
          client: "Sarah Ahmed",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "Britisches Handelsgericht",
          date: "Januar 2024",
          caseNumber: "BC-2023-001592",
          description: "Gerichtsurteil zur Geldrückgewinnung von nicht lizenziertem Binäroptionsunternehmen"
        },
        {
          client: "Ahmed Al Khatib",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "Britischer High Court",
          date: "November 2023",
          caseNumber: "HC-2023-001203",
          description: "Größter Rückgewinnungsfall in der Firmengeschichte von betrügerischer Kryptowährungsplattform"
        },
        {
          client: "Laila Hassan",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "Britisches Zivilgericht",
          date: "September 2023",
          caseNumber: "CC-2023-000876",
          description: "Geldrückgewinnung mit gesetzlichen Zinsen von gefälschtem Investmentunternehmen"
        }
      ]
    },
    howItWorks: {
      title: "Wie wir Ihr Geld zurückholen",
      subtitle: "Klarer und strategischer Prozess von der Beratung bis zur Rückgewinnung",
      steps: [
        {
          number: "01",
          title: "Erstberatung",
          description: "Kontaktieren Sie uns kostenlos und teilen Sie uns Ihre Falldetails mit. Wir bewerten Ihren Fall und bestimmen die Möglichkeit der Geldrückgewinnung innerhalb von 24 Stunden."
        },
        {
          number: "02",
          title: "Beweissammlung",
          description: "Wir sammeln alle notwendigen Dokumente und Beweise: Transaktionsaufzeichnungen, Korrespondenz, Screenshots und jegliche Beweise für Betrug."
        },
        {
          number: "03",
          title: "Rechtliche Untersuchung",
          description: "Wir untersuchen das betrügerische Unternehmen, verfolgen seine Vermögenswerte und bestimmen die geeignete Gerichtsbarkeit für die Klageeinreichung."
        },
        {
          number: "04",
          title: "Klageeinreichung",
          description: "Wir reichen eine offizielle Klage vor britischen oder europäischen Gerichten gegen das betrügerische Unternehmen und seine Verantwortlichen ein."
        },
        {
          number: "05",
          title: "Prozessführung & Nachverfolgung",
          description: "Wir vertreten Sie vor Gericht, legen Beweise vor und verfolgen den Fall bis zur Erlangung eines günstigen Urteils."
        },
        {
          number: "06",
          title: "Urteilsvollstreckung & Geldrückgewinnung",
          description: "Nach dem Urteil verfolgen wir rechtlich dessen Vollstreckung bis zur vollständigen Rückgewinnung Ihrer Gelder mit Entschädigung auf Ihr Bankkonto."
        }
      ]
    },
    faq: {
      title: "Häufig gestellte Fragen",
      subtitle: "Antworten auf Ihre wichtigsten Fragen zur Geldrückgewinnung",
      questions: [
        {
          q: "Wie hoch ist die Erfolgsquote bei der Geldrückgewinnung?",
          a: "Unsere Erfolgsquote liegt bei den von uns angenommenen Fällen über 87%. Wir führen eine gründliche Bewertung jedes Falles vor der Annahme durch, um höchste Erfolgschancen zu gewährleisten. Wir arbeiten nur an Fällen, bei denen wir starkes Vertrauen in den Gewinn haben."
        },
        {
          q: "Wie lange dauert der Geldrückgewinnungsprozess?",
          a: "Der Prozess dauert in der Regel zwischen 6 und 18 Monaten, abhängig von der Fallkomplexität und Gerichtsbarkeit. Einfache Fälle können in 4-6 Monaten gelöst werden, während komplexe internationale Fälle bis zu 24 Monate dauern können. Wir halten Sie ständig über den Fortschritt Ihres Falles auf dem Laufenden."
        },
        {
          q: "Was sind die Kosten für rechtliche Dienstleistungen?",
          a: "Wir arbeiten in den meisten Fällen auf Erfolgsbasis (Kein Gewinn, keine Gebühr). Sie zahlen nichts im Voraus, und wir erhalten einen vereinbarten Prozentsatz nur bei Fallerfolg und Geldrückgewinnung. Die Erstberatung ist völlig kostenlos."
        },
        {
          q: "Kann ich meine Gelder zurückerhalten, wenn das Unternehmen außerhalb meines Landes ansässig ist?",
          a: "Ja, wir sind auf internationale Fälle spezialisiert. Wir haben Erfahrung im Umgang mit betrügerischen Unternehmen in verschiedenen Ländern. Wir reichen Fälle vor britischen und europäischen Gerichten ein, die eine breite Zuständigkeit in internationalen Betrugsfällen haben."
        },
        {
          q: "Welche Dokumente werden benötigt, um den Fall zu starten?",
          a: "Wir benötigen: Bank- oder elektronische Überweisungsaufzeichnungen, Plattform-Screenshots, Korrespondenz mit dem Unternehmen (E-Mails, Nachrichten), Verträge oder Vereinbarungen, die Sie unterzeichnet haben, und jedes Dokument, das Ihre Beziehung zum Unternehmen beweist. Auch wenn Sie nicht alles haben, können wir mit dem beginnen, was Sie haben."
        },
        {
          q: "Was ist, wenn das Unternehmen seine Website geschlossen hat und verschwunden ist?",
          a: "Dies verhindert keine Geldrückgewinnung. Wir verwenden fortgeschrittene Ermittlungstechniken, um das Unternehmen und seine Verantwortlichen zu verfolgen und seine Vermögenswerte und Bankkonten zu identifizieren. Viele unserer erfolgreichen Fälle waren gegen Unternehmen, die scheinbar 'verschwunden' waren."
        },
        {
          q: "Ist die Erstberatung wirklich kostenlos?",
          a: "Ja, die Erstberatung ist zu 100% kostenlos ohne jegliche Verpflichtung. Wir überprüfen Ihren Fall, bewerten die Erfolgschancen und stellen Ihnen einen klaren Aktionsplan zur Verfügung. Sie zahlen nichts, es sei denn, Sie entscheiden sich fortzufahren und wir nehmen Ihren Fall an."
        },
        {
          q: "Behandeln Sie Kryptowährungsfälle?",
          a: "Ja, wir haben umfangreiche Erfahrung in Kryptowährungsbetrugsf_cases einschließlich betrügerischer ICOs, gefälschter Handelsplattformen, Krypto-Ponzi-Systeme und Wallet-Diebstahl. Wir haben Millionen von Dollar in diesem Bereich zurückgeholt."
        }
      ]
    },
    testimonials: {
      title: "Kundenmeinungen",
      subtitle: "Echte Erfolgsgeschichten von Kunden, die ihre Gelder zurückerhalten haben",
      list: [
        {
          name: "Mohammed Al Ali",
          location: "Vereinigte Arabische Emirate",
          amount: "$847,500",
          text: "Ich hätte nie gedacht, dass ich mein Geld zurückbekommen würde, nachdem das Unternehmen verschwunden war. Dr. Qasim Hussein und sein Team waren äußerst professionell und verfolgten den Fall bis zum Ende. Ich erhielt mein gesamtes Geld mit zusätzlicher Entschädigung zurück. Vielen Dank!",
          rating: 5
        },
        {
          name: "Sarah Ahmed",
          location: "Saudi-Arabien",
          amount: "$625,000",
          text: "Ich verlor meine Lebensersparnisse bei einem betrügerischen Binäroptionsunternehmen. Dr. Qasim gab mir Hoffnung zurück und gelang es, mein Geld innerhalb von 11 Monaten zurückzuholen. Der Prozess war transparent und ich wurde immer informiert. Ich empfehle jedem, sich mit ihm in Verbindung zu setzen.",
          rating: 5
        },
        {
          name: "Ahmed Al Khatib",
          location: "Kuwait",
          amount: "$1,240,000",
          text: "Mehr als eine Million Dollar waren auf einer gefälschten Kryptowährungsplattform verloren. Dr. Qasim und sein Team erreichten das Unmögliche und holten den gesamten Betrag zurück. Die Professionalität und rechtliche Expertise, die sie besaßen, waren erstaunlich.",
          rating: 5
        },
        {
          name: "Laila Hassan",
          location: "Katar",
          amount: "$395,000",
          text: "Nachdem ich die Hoffnung verloren hatte, mein Geld zurückzubekommen, fand ich Dr. Qasim Hussein. Er holte nicht nur mein Geld zurück, sondern erhielt auch zusätzliche Entschädigung für Schäden für mich. Dank von Herzen an diesen ehrlichen Anwalt.",
          rating: 5
        }
      ]
    },
    contact: {
      title: "Holen Sie sich jetzt Ihre kostenlose Beratung",
      subtitle: "Kontaktieren Sie uns heute und beginnen Sie Ihre Geldrückgewinnungsreise",
      form: {
        name: "Vollständiger Name",
        email: "E-Mail-Adresse",
        phone: "Telefonnummer",
        amount: "Gestohlener Betrag (USD)",
        company: "Name des betrügerischen Unternehmens",
        message: "Falldetails",
        submit: "Anfrage senden",
        sending: "Wird gesendet...",
        success: "Ihre Anfrage wurde erfolgreich eingereicht! Wir werden uns innerhalb von 24 Stunden bei Ihnen melden.",
        error: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
      },
      info: {
        title: "Kontaktinformationen",
        address: "London, Vereinigtes Königreich",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "Sonntag - Donnerstag: 9:00 - 18:00 Uhr"
      }
    },
    footer: {
      description: "Dr. Qasim Hussein Anwaltskanzlei - Spezialisten für Geldrückgewinnung von betrügerischen Handelsunternehmen",
      quickLinks: "Schnelllinks",
      legal: "Rechtliches",
      privacy: "Datenschutzrichtlinie",
      terms: "Geschäftsbedingungen",
      disclaimer: "Haftungsausschluss",
      copyright: "© 2024 Dr. Qasim Hussein. Alle Rechte vorbehalten.",
      followUs: "Folgen Sie uns"
    }
  },
  fr: {
    // UI Common
    ui: {
      lawyerName: "Dr. Qasim Hussein",
      lawyerTitle: "Avocat international certifié",
      britishCertified: "Certifié tribunaux britanniques",
      verifyLicense: "Vérifier la licence",
      verifySRALicense: "Vérifier la licence SRA",
      chatWhatsApp: "Discuter sur WhatsApp",
      chatWithUs: "Discuter avec nous",
      selectLanguage: "Sélectionner la langue",
      fcaRegulated: "Réglementé FCA",
      noWinNoFee: "Pas de gain, pas de frais",
      scroll: "Défiler",
      amountRecovered: "Montant récupéré",
      verified: "Vérifié",
      watchFullStory: "Voir l'histoire complète",
      verifiedSuccessStory: "Histoire de succès vérifiée",
      moreClientReviews: "Plus d'avis clients",
      recovered: "Récupéré",
      readyToRecover: "Prêt à récupérer votre argent?",
      haveMoreQuestions: "Avez-vous d'autres questions?",
      contactDirectly: "Contactez-nous directement pour une consultation gratuite et personnalisée",
      address: "Adresse",
      email: "E-mail",
      phone: "Téléphone",
      workingHours: "Heures de travail",
      freeConsultation: "Consultation 100% gratuite",
      noObligation: "Sans obligation - Pas de gain, pas de frais",
      responseTime: "Temps de réponse",
      languages: "Langues",
      clientRating: "Évaluation client",
      satisfaction: "Satisfaction",
      happyClients: "Clients satisfaits",
      freeConsult: "Consultation gratuite",
      inFavourOfClaimant: "EN FAVEUR DU DEMANDEUR",
      aboutLawyer: "À propos de l'avocat",
      areasOfExpertise: "Domaines d'expertise",
      backToWebsite: "Retour au site",
      responseWithin24h: "Réponse sous 24h",
      confidential: "100% confidentiel",
      yearsExperience: "Ans d'expérience",
      casesWon: "Cas gagnés",
      getConsultationNow: "Obtenir une consultation gratuite maintenant",
      recoverFundsNow: "Récupérez votre argent maintenant!",
      startRecoveryJourney: "Contactez-nous aujourd'hui et commencez votre parcours de récupération",
      fullName: "Nom complet",
      phoneNumber: "Numéro de téléphone",
      emailAddress: "Adresse e-mail",
      amountLost: "Montant perdu (USD)",
      sraLicensed: "Licencié SRA",
      successRate: "87% de réussite",
      sending: "Envoi en cours...",
      videoTestimonials: "Témoignages vidéo de nos clients"
    },
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      cases: "Cas réussis",
      howItWorks: "Comment ça marche",
      faq: "FAQ",
      contact: "Contact",
      consultation: "Consultation gratuite"
    },
    hero: {
      title: "Récupérez votre argent des sociétés de trading frauduleuses",
      subtitle: "Dr. Qasim Hussein - Avocat expert spécialisé dans la récupération de fonds auprès de courtiers Forex et d'options binaires frauduleux",
      cta: "Obtenir une consultation gratuite",
      secondaryCta: "En savoir plus",
      stats: {
        cases: "Cas réussis",
        recovered: "Millions récupérés",
        clients: "Clients satisfaits",
        rate: "Taux de réussite"
      }
    },
    about: {
      title: "À propos du Dr. Qasim Hussein",
      subtitle: "Expertise juridique spécialisée en récupération de fonds",
      description: "Le Dr. Qasim Hussein est un avocat international spécialisé dans les affaires de fraude financière et la récupération de fonds auprès de sociétés de trading et de courtage frauduleuses. Avec plus de 15 ans d'expérience en litiges internationaux, il a réussi à récupérer des millions de dollars pour ses clients via les tribunaux britanniques et européens.",
      expertise: [
        "Récupération de fonds auprès de courtiers Forex frauduleux",
        "Affaires d'options binaires et de crypto-monnaie",
        "Litiges internationaux devant les tribunaux britanniques",
        "Récupération auprès de plateformes de trading non licenciées",
        "Compensation juridique pour fraude financière"
      ],
      certifications: "Certifications et qualifications",
      certs: [
        "Doctorat en droit commercial international",
        "Membre du Barreau britannique",
        "Avocat certifié dans les tribunaux européens",
        "Expert en droit des valeurs mobilières et des investissements"
      ]
    },
    services: {
      title: "Nos services juridiques",
      subtitle: "Solutions complètes pour votre récupération de fonds",
      list: [
        {
          title: "Évaluation gratuite du cas",
          description: "Analyse complète de votre cas et évaluation des chances de succès avec consultation juridique gratuite",
          icon: "FileSearch"
        },
        {
          title: "Enquête et recherche",
          description: "Collecte des preuves et documents nécessaires pour prouver la fraude et traquer les sociétés frauduleuses",
          icon: "Search"
        },
        {
          title: "Procédures juridiques",
          description: "Dépôt de poursuites devant les tribunaux britanniques et internationaux contre les sociétés frauduleuses",
          icon: "Scale"
        },
        {
          title: "Récupération de fonds",
          description: "Suivi diligent jusqu'à la récupération complète de vos fonds avec compensation juridique",
          icon: "DollarSign"
        },
        {
          title: "Support continu",
          description: "Vous accompagner à chaque étape du processus juridique avec des rapports de progrès réguliers",
          icon: "HeadphonesIcon"
        },
        {
          title: "Protection juridique",
          description: "Fournir des conseils pour vous protéger contre la fraude future et sécuriser vos investissements",
          icon: "Shield"
        }
      ]
    },
    cases: {
      title: "Cas de réussite documentés",
      subtitle: "Victoires juridiques soutenues par des documents des tribunaux britanniques",
      viewDocument: "Voir le document",
      list: [
        {
          client: "Mohammed Al Ali",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "Haute Cour britannique",
          date: "Mars 2024",
          caseNumber: "HC-2023-002847",
          description: "Récupération complète des fonds volés sur une plateforme Forex frauduleuse avec compensation supplémentaire"
        },
        {
          client: "Sarah Ahmed",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "Tribunal de commerce britannique",
          date: "Janvier 2024",
          caseNumber: "BC-2023-001592",
          description: "Jugement du tribunal pour la récupération de fonds auprès d'une société d'options binaires non licenciée"
        },
        {
          client: "Ahmed Al Khatib",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "Haute Cour britannique",
          date: "Novembre 2023",
          caseNumber: "HC-2023-001203",
          description: "Plus grand cas de récupération dans l'histoire du cabinet auprès d'une plateforme de crypto-monnaie frauduleuse"
        },
        {
          client: "Laila Hassan",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "Tribunal civil britannique",
          date: "Septembre 2023",
          caseNumber: "CC-2023-000876",
          description: "Récupération de fonds avec intérêts légaux auprès d'une fausse société d'investissement"
        }
      ]
    },
    howItWorks: {
      title: "Comment nous récupérons votre argent",
      subtitle: "Processus clair et stratégique de la consultation à la récupération",
      steps: [
        {
          number: "01",
          title: "Consultation initiale",
          description: "Contactez-nous gratuitement et partagez les détails de votre cas. Nous évaluerons votre cas et déterminerons la possibilité de récupération de fonds dans les 24 heures."
        },
        {
          number: "02",
          title: "Collecte de preuves",
          description: "Nous collectons tous les documents et preuves nécessaires : enregistrements de transactions, correspondance, captures d'écran et toute preuve de fraude."
        },
        {
          number: "03",
          title: "Enquête juridique",
          description: "Nous enquêtons sur la société frauduleuse, suivons ses actifs et déterminons la juridiction appropriée pour déposer la poursuite."
        },
        {
          number: "04",
          title: "Dépôt de poursuite",
          description: "Nous déposons une poursuite officielle devant les tribunaux britanniques ou européens contre la société frauduleuse et ses responsables."
        },
        {
          number: "05",
          title: "Litige et suivi",
          description: "Nous vous représentons au tribunal, présentons des preuves et suivons l'affaire jusqu'à l'obtention d'un jugement favorable."
        },
        {
          number: "06",
          title: "Exécution du jugement et récupération de fonds",
          description: "Après le jugement, nous suivons légalement son exécution jusqu'à la récupération complète de vos fonds avec compensation sur votre compte bancaire."
        }
      ]
    },
    faq: {
      title: "Questions fréquemment posées",
      subtitle: "Réponses à vos questions les plus importantes sur la récupération de fonds",
      questions: [
        {
          q: "Quel est le taux de réussite de la récupération de fonds?",
          a: "Notre taux de réussite dépasse 87% dans les cas que nous acceptons. Nous effectuons une évaluation approfondie de chaque cas avant l'acceptation pour garantir les plus grandes chances de succès. Nous travaillons uniquement sur des cas dans lesquels nous avons une forte confiance de gagner."
        },
        {
          q: "Combien de temps prend le processus de récupération de fonds?",
          a: "Le processus prend généralement entre 6 et 18 mois selon la complexité du cas et la juridiction. Les cas simples peuvent être résolus en 4-6 mois, tandis que les cas internationaux complexes peuvent prendre jusqu'à 24 mois. Nous vous tenons constamment informé de l'avancement de votre cas."
        },
        {
          q: "Quels sont les coûts des services juridiques?",
          a: "Nous travaillons sur une base d'honoraires conditionnels (Pas de gain, pas de frais) dans la plupart des cas. Vous ne payez rien d'avance, et nous recevons un pourcentage convenu uniquement en cas de succès du cas et de récupération de fonds. La consultation initiale est totalement gratuite."
        },
        {
          q: "Puis-je récupérer mes fonds si la société est basée en dehors de mon pays?",
          a: "Oui, nous nous spécialisons dans les cas internationaux. Nous avons de l'expérience dans le traitement de sociétés frauduleuses dans divers pays. Nous déposons des cas devant les tribunaux britanniques et européens qui ont une large juridiction dans les affaires de fraude internationale."
        },
        {
          q: "Quels documents sont nécessaires pour démarrer le cas?",
          a: "Nous avons besoin de : enregistrements de virements bancaires ou électroniques, captures d'écran de la plateforme, correspondance avec la société (e-mails, messages), contrats ou accords que vous avez signés, et tout document prouvant votre relation avec la société. Même si vous n'avez pas tout, nous pouvons commencer avec ce que vous avez."
        },
        {
          q: "Que se passe-t-il si la société a fermé son site Web et a disparu?",
          a: "Cela n'empêche pas la récupération de fonds. Nous utilisons des techniques d'enquête avancées pour traquer la société et ses responsables, et identifier ses actifs et comptes bancaires. Beaucoup de nos cas réussis concernaient des sociétés qui avaient apparemment 'disparu'."
        },
        {
          q: "La consultation initiale est-elle vraiment gratuite?",
          a: "Oui, la consultation initiale est 100% gratuite sans aucune obligation. Nous examinerons votre cas, évaluerons les chances de succès et vous fournirons un plan d'action clair. Vous ne paierez rien à moins que vous ne décidiez de continuer et que nous acceptions votre cas."
        },
        {
          q: "Gérez-vous les cas de crypto-monnaie?",
          a: "Oui, nous avons une vaste expérience dans les affaires de fraude aux crypto-monnaies, y compris les ICO frauduleuses, les fausses plateformes de trading, les schémas de Ponzi crypto et le vol de portefeuilles. Nous avons récupéré des millions de dollars dans ce domaine."
        }
      ]
    },
    testimonials: {
      title: "Témoignages de clients",
      subtitle: "Histoires de réussite réelles de clients qui ont récupéré leurs fonds",
      list: [
        {
          name: "Mohammed Al Ali",
          location: "Émirats arabes unis",
          amount: "$847,500",
          text: "Je n'ai jamais imaginé que je récupérerais mon argent après la disparition de la société. Le Dr. Qasim Hussein et son équipe étaient extrêmement professionnels et ont suivi le cas jusqu'à la fin. J'ai récupéré tout mon argent avec une compensation supplémentaire. Merci beaucoup!",
          rating: 5
        },
        {
          name: "Sarah Ahmed",
          location: "Arabie saoudite",
          amount: "$625,000",
          text: "J'ai perdu les économies de ma vie dans une société d'options binaires frauduleuse. Le Dr. Qasim m'a redonné de l'espoir et a réussi à récupérer mon argent en 11 mois. Le processus était transparent et j'étais toujours informée. Je recommande à tous de le contacter.",
          rating: 5
        },
        {
          name: "Ahmed Al Khatib",
          location: "Koweït",
          amount: "$1,240,000",
          text: "Plus d'un million de dollars ont été perdus sur une fausse plateforme de crypto-monnaie. Le Dr. Qasim et son équipe ont accompli l'impossible et ont récupéré le montant total. Le professionnalisme et l'expertise juridique dont ils ont fait preuve étaient incroyables.",
          rating: 5
        },
        {
          name: "Laila Hassan",
          location: "Qatar",
          amount: "$395,000",
          text: "Après avoir perdu espoir de récupérer mon argent, j'ai trouvé le Dr. Qasim Hussein. Il n'a pas seulement récupéré mon argent, mais a également obtenu pour moi une compensation supplémentaire pour les dommages. Merci du fond du cœur à cet avocat honnête.",
          rating: 5
        }
      ]
    },
    contact: {
      title: "Obtenez votre consultation gratuite maintenant",
      subtitle: "Contactez-nous aujourd'hui et commencez votre parcours de récupération de fonds",
      form: {
        name: "Nom complet",
        email: "Adresse e-mail",
        phone: "Numéro de téléphone",
        amount: "Montant volé (USD)",
        company: "Nom de la société frauduleuse",
        message: "Détails du cas",
        submit: "Envoyer la demande",
        sending: "Envoi en cours...",
        success: "Votre demande a été soumise avec succès! Nous vous contacterons dans les 24 heures.",
        error: "Une erreur s'est produite. Veuillez réessayer."
      },
      info: {
        title: "Informations de contact",
        address: "Londres, Royaume-Uni",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "Dimanche - Jeudi: 9h00 - 18h00"
      }
    },
    footer: {
      description: "Cabinet d'avocats Dr. Qasim Hussein - Spécialistes de la récupération de fonds auprès de sociétés de trading frauduleuses",
      quickLinks: "Liens rapides",
      legal: "Juridique",
      privacy: "Politique de confidentialité",
      terms: "Termes et conditions",
      disclaimer: "Avertissement",
      copyright: "© 2024 Dr. Qasim Hussein. Tous droits réservés.",
      followUs: "Suivez-nous"
    }
  },
  es: {
    // UI Common
    ui: {
      lawyerName: "Dr. Qasim Hussein",
      lawyerTitle: "Abogado internacional certificado",
      britishCertified: "Certificado por tribunales británicos",
      verifyLicense: "Verificar licencia",
      verifySRALicense: "Verificar licencia SRA",
      chatWhatsApp: "Chatear por WhatsApp",
      chatWithUs: "Chatear con nosotros",
      selectLanguage: "Seleccionar idioma",
      fcaRegulated: "Regulado por FCA",
      noWinNoFee: "Sin victoria, sin honorarios",
      scroll: "Desplazar",
      amountRecovered: "Monto recuperado",
      verified: "Verificado",
      watchFullStory: "Ver historia completa",
      verifiedSuccessStory: "Historia de éxito verificada",
      moreClientReviews: "Más reseñas de clientes",
      recovered: "Recuperado",
      readyToRecover: "¿Listo para recuperar su dinero?",
      haveMoreQuestions: "¿Tiene más preguntas?",
      contactDirectly: "Contáctenos directamente para una consulta gratuita y personalizada",
      address: "Dirección",
      email: "Correo electrónico",
      phone: "Teléfono",
      workingHours: "Horario de trabajo",
      freeConsultation: "Consulta 100% gratuita",
      noObligation: "Sin compromiso - Sin victoria, sin honorarios",
      responseTime: "Tiempo de respuesta",
      languages: "Idiomas",
      clientRating: "Calificación del cliente",
      satisfaction: "Satisfacción",
      happyClients: "Clientes felices",
      freeConsult: "Consulta gratis",
      inFavourOfClaimant: "A FAVOR DEL DEMANDANTE",
      aboutLawyer: "Sobre el abogado",
      areasOfExpertise: "Áreas de experiencia",
      backToWebsite: "Volver al sitio",
      responseWithin24h: "Respuesta en 24h",
      confidential: "100% confidencial",
      yearsExperience: "Años de exp.",
      casesWon: "Casos ganados",
      getConsultationNow: "Obtener consulta gratuita ahora",
      recoverFundsNow: "¡Recupere su dinero ahora!",
      startRecoveryJourney: "Contáctenos hoy y comience su viaje de recuperación",
      fullName: "Nombre completo",
      phoneNumber: "Número de teléfono",
      emailAddress: "Correo electrónico",
      amountLost: "Monto perdido (USD)",
      sraLicensed: "Licenciado SRA",
      successRate: "87% de éxito",
      sending: "Enviando...",
      videoTestimonials: "Testimonios en video de nuestros clientes"
    },
    nav: {
      home: "Inicio",
      about: "Acerca de",
      services: "Servicios",
      cases: "Casos exitosos",
      howItWorks: "Cómo funciona",
      faq: "Preguntas frecuentes",
      contact: "Contacto",
      consultation: "Consulta gratuita"
    },
    hero: {
      title: "Recupere su dinero de compañías comerciales fraudulentas",
      subtitle: "Dr. Qasim Hussein - Abogado experto especializado en recuperación de fondos de corredores de Forex y opciones binarias fraudulentos",
      cta: "Obtener consulta gratuita",
      secondaryCta: "Saber más",
      stats: {
        cases: "Casos exitosos",
        recovered: "Millones recuperados",
        clients: "Clientes satisfechos",
        rate: "Tasa de éxito"
      }
    },
    about: {
      title: "Acerca del Dr. Qasim Hussein",
      subtitle: "Experiencia legal especializada en recuperación de fondos",
      description: "El Dr. Qasim Hussein es un abogado internacional especializado en casos de fraude financiero y recuperación de fondos de compañías comerciales y de corretaje fraudulentas. Con más de 15 años de experiencia en litigios internacionales, ha recuperado exitosamente millones de dólares para sus clientes a través de tribunales británicos y europeos.",
      expertise: [
        "Recuperación de fondos de corredores de Forex fraudulentos",
        "Casos de opciones binarias y criptomonedas",
        "Litigios internacionales en tribunales británicos",
        "Recuperación de plataformas comerciales sin licencia",
        "Compensación legal por fraude financiero"
      ],
      certifications: "Certificaciones y calificaciones",
      certs: [
        "Doctorado en Derecho Comercial Internacional",
        "Miembro de la Asociación del Colegio de Abogados Británico",
        "Abogado certificado en tribunales europeos",
        "Experto en Derecho de Valores e Inversiones"
      ]
    },
    services: {
      title: "Nuestros servicios legales",
      subtitle: "Soluciones integrales para su recuperación de fondos",
      list: [
        {
          title: "Evaluación gratuita del caso",
          description: "Análisis completo de su caso y evaluación de las posibilidades de éxito con consulta legal gratuita",
          icon: "FileSearch"
        },
        {
          title: "Investigación e investigación",
          description: "Recopilación de pruebas y documentos necesarios para probar el fraude y rastrear compañías fraudulentas",
          icon: "Search"
        },
        {
          title: "Procedimientos legales",
          description: "Presentación de demandas en tribunales británicos e internacionales contra compañías fraudulentas",
          icon: "Scale"
        },
        {
          title: "Recuperación de fondos",
          description: "Seguimiento diligente hasta la recuperación completa de sus fondos con compensación legal",
          icon: "DollarSign"
        },
        {
          title: "Apoyo continuo",
          description: "Acompañándolo en cada paso del proceso legal con informes regulares de progreso",
          icon: "HeadphonesIcon"
        },
        {
          title: "Protección legal",
          description: "Proporcionar asesoramiento para protegerlo del fraude futuro y asegurar sus inversiones",
          icon: "Shield"
        }
      ]
    },
    cases: {
      title: "Casos de éxito documentados",
      subtitle: "Victorias legales respaldadas por documentos de tribunales británicos",
      viewDocument: "Ver documento",
      list: [
        {
          client: "Mohammed Al Ali",
          amount: "$847,500",
          company: "Capital Market FX",
          court: "Tribunal Superior Británico",
          date: "Marzo 2024",
          caseNumber: "HC-2023-002847",
          description: "Recuperación total de fondos robados de plataforma de Forex fraudulenta con compensación adicional"
        },
        {
          client: "Sarah Ahmed",
          amount: "$625,000",
          company: "Binary Options Pro",
          court: "Tribunal Comercial Británico",
          date: "Enero 2024",
          caseNumber: "BC-2023-001592",
          description: "Sentencia judicial para recuperación de fondos de compañía de opciones binarias sin licencia"
        },
        {
          client: "Ahmed Al Khatib",
          amount: "$1,240,000",
          company: "Crypto Trade Global",
          court: "Tribunal Superior Británico",
          date: "Noviembre 2023",
          caseNumber: "HC-2023-001203",
          description: "Mayor caso de recuperación en la historia de la firma de plataforma de criptomonedas fraudulenta"
        },
        {
          client: "Laila Hassan",
          amount: "$395,000",
          company: "Global Investment Ltd",
          court: "Tribunal Civil Británico",
          date: "Septiembre 2023",
          caseNumber: "CC-2023-000876",
          description: "Recuperación de fondos con intereses legales de compañía de inversión falsa"
        }
      ]
    },
    howItWorks: {
      title: "Cómo recuperamos su dinero",
      subtitle: "Proceso claro y estratégico desde la consulta hasta la recuperación",
      steps: [
        {
          number: "01",
          title: "Consulta inicial",
          description: "Contáctenos gratis y comparta los detalles de su caso. Evaluaremos su caso y determinaremos la posibilidad de recuperación de fondos en 24 horas."
        },
        {
          number: "02",
          title: "Recopilación de pruebas",
          description: "Recopilamos todos los documentos y pruebas necesarios: registros de transacciones, correspondencia, capturas de pantalla y cualquier prueba de fraude."
        },
        {
          number: "03",
          title: "Investigación legal",
          description: "Investigamos la compañía fraudulenta, rastreamos sus activos y determinamos la jurisdicción apropiada para presentar la demanda."
        },
        {
          number: "04",
          title: "Presentación de demanda",
          description: "Presentamos una demanda oficial en tribunales británicos o europeos contra la compañía fraudulenta y sus funcionarios."
        },
        {
          number: "05",
          title: "Litigio y seguimiento",
          description: "Lo representamos en el tribunal, presentamos pruebas y seguimos el caso hasta obtener un fallo favorable."
        },
        {
          number: "06",
          title: "Ejecución del fallo y recuperación de fondos",
          description: "Después del fallo, seguimos legalmente su ejecución hasta la recuperación completa de sus fondos con compensación en su cuenta bancaria."
        }
      ]
    },
    faq: {
      title: "Preguntas frecuentes",
      subtitle: "Respuestas a sus preguntas más importantes sobre recuperación de fondos",
      questions: [
        {
          q: "¿Cuál es la tasa de éxito para la recuperación de fondos?",
          a: "Nuestra tasa de éxito supera el 87% en los casos que aceptamos. Realizamos una evaluación exhaustiva de cada caso antes de la aceptación para garantizar las mayores posibilidades de éxito. Solo trabajamos en casos en los que tenemos una fuerte confianza en ganar."
        },
        {
          q: "¿Cuánto tiempo toma el proceso de recuperación de fondos?",
          a: "El proceso generalmente toma entre 6 y 18 meses dependiendo de la complejidad del caso y la jurisdicción. Los casos simples pueden resolverse en 4-6 meses, mientras que los casos internacionales complejos pueden tomar hasta 24 meses. Lo mantenemos constantemente actualizado sobre el progreso de su caso."
        },
        {
          q: "¿Cuáles son los costos de los servicios legales?",
          a: "Trabajamos con honorarios contingentes (Sin ganancia, sin tarifa) en la mayoría de los casos. No paga nada por adelantado, y recibimos un porcentaje acordado solo en caso de éxito del caso y recuperación de fondos. La consulta inicial es completamente gratuita."
        },
        {
          q: "¿Puedo recuperar mis fondos si la compañía tiene su sede fuera de mi país?",
          a: "Sí, nos especializamos en casos internacionales. Tenemos experiencia en el trato con compañías fraudulentas en varios países. Presentamos casos en tribunales británicos y europeos que tienen amplia jurisdicción en casos de fraude internacional."
        },
        {
          q: "¿Qué documentos se requieren para iniciar el caso?",
          a: "Necesitamos: registros de transferencias bancarias o electrónicas, capturas de pantalla de la plataforma, correspondencia con la compañía (correos electrónicos, mensajes), contratos o acuerdos que haya firmado, y cualquier documento que demuestre su relación con la compañía. Incluso si no tiene todo, podemos comenzar con lo que tiene."
        },
        {
          q: "¿Qué pasa si la compañía cerró su sitio web y desapareció?",
          a: "Esto no impide la recuperación de fondos. Utilizamos técnicas de investigación avanzadas para rastrear la compañía y sus funcionarios, e identificar sus activos y cuentas bancarias. Muchos de nuestros casos exitosos fueron contra compañías que aparentemente 'desaparecieron'."
        },
        {
          q: "¿La consulta inicial es realmente gratuita?",
          a: "Sí, la consulta inicial es 100% gratuita sin ninguna obligación. Revisaremos su caso, evaluaremos las posibilidades de éxito y le proporcionaremos un plan de acción claro. No pagará nada a menos que decida continuar y aceptemos su caso."
        },
        {
          q: "¿Manejan casos de criptomonedas?",
          a: "Sí, tenemos amplia experiencia en casos de fraude de criptomonedas incluyendo ICOs fraudulentas, plataformas comerciales falsas, esquemas Ponzi de criptomonedas y robo de billeteras. Hemos recuperado millones de dólares en este campo."
        }
      ]
    },
    testimonials: {
      title: "Testimonios de clientes",
      subtitle: "Historias de éxito reales de clientes que recuperaron sus fondos",
      list: [
        {
          name: "Mohammed Al Ali",
          location: "Emiratos Árabes Unidos",
          amount: "$847,500",
          text: "Nunca imaginé que recuperaría mi dinero después de que la compañía desapareció. El Dr. Qasim Hussein y su equipo fueron extremadamente profesionales y siguieron el caso hasta el final. Recuperé todo mi dinero con compensación adicional. ¡Muchas gracias!",
          rating: 5
        },
        {
          name: "Sarah Ahmed",
          location: "Arabia Saudita",
          amount: "$625,000",
          text: "Perdí los ahorros de mi vida en una compañía fraudulenta de opciones binarias. El Dr. Qasim me devolvió la esperanza y logró recuperar mi dinero en 11 meses. El proceso fue transparente y siempre estuve informada. Recomiendo a todos que se pongan en contacto con él.",
          rating: 5
        },
        {
          name: "Ahmed Al Khatib",
          location: "Kuwait",
          amount: "$1,240,000",
          text: "Más de un millón de dólares se perdieron en una plataforma de criptomonedas falsa. El Dr. Qasim y su equipo lograron lo imposible y recuperaron el monto completo. El profesionalismo y la experiencia legal que poseían fueron asombrosos.",
          rating: 5
        },
        {
          name: "Laila Hassan",
          location: "Qatar",
          amount: "$395,000",
          text: "Después de perder la esperanza de recuperar mi dinero, encontré al Dr. Qasim Hussein. No solo recuperó mi dinero, sino que también me consiguió compensación adicional por daños. Gracias de corazón a este abogado honesto.",
          rating: 5
        }
      ]
    },
    contact: {
      title: "Obtenga su consulta gratuita ahora",
      subtitle: "Contáctenos hoy y comience su viaje de recuperación de fondos",
      form: {
        name: "Nombre completo",
        email: "Dirección de correo electrónico",
        phone: "Número de teléfono",
        amount: "Cantidad robada (USD)",
        company: "Nombre de la compañía fraudulenta",
        message: "Detalles del caso",
        submit: "Enviar solicitud",
        sending: "Enviando...",
        success: "¡Su solicitud ha sido enviada con éxito! Nos pondremos en contacto con usted dentro de 24 horas.",
        error: "Ocurrió un error. Por favor intente de nuevo."
      },
      info: {
        title: "Información de contacto",
        address: "Londres, Reino Unido",
        email: "info@qasimlaw.com",
        phone: "+44 20 1234 5678",
        hours: "Domingo - Jueves: 9:00 AM - 6:00 PM"
      }
    },
    footer: {
      description: "Firma de abogados Dr. Qasim Hussein - Especialistas en recuperación de fondos de compañías comerciales fraudulentas",
      quickLinks: "Enlaces rápidos",
      legal: "Legal",
      privacy: "Política de privacidad",
      terms: "Términos y condiciones",
      disclaimer: "Descargo de responsabilidad",
      copyright: "© 2024 Dr. Qasim Hussein. Todos los derechos reservados.",
      followUs: "Síguenos"
    }
  }
};

// Court documents images
export const courtDocuments = [
  "https://images.unsplash.com/photo-1619418602850-35ad20aa1700",
  "https://images.pexels.com/photos/48148/document-agreement-documents-sign-48148.jpeg",
  "https://images.pexels.com/photos/7876050/pexels-photo-7876050.jpeg"
];

// Professional images
export const professionalImages = {
  hero: "https://images.unsplash.com/photo-1768839722927-df0ef3188f6d",
  lawyer: "https://images.unsplash.com/photo-1658249682512-1bb162538ba9",
  justice: "https://images.unsplash.com/photo-1760089449852-e8cade7feb53",
  gavel1: "https://images.unsplash.com/photo-1767972463877-b64ba4283cd0",
  gavel2: "https://images.unsplash.com/photo-1767972159871-b9f5d320be2b",
  gavel3: "https://images.unsplash.com/photo-1767972159674-460283907c21"
};
